import React, { useEffect, useState } from 'react';
import { ArrowDownTrayIcon, ChevronRightIcon } from '@heroicons/react/20/solid';

import { Button, TemplateModal } from '@nearst/ui';
import { customiseProduct, listStockRecords } from '@services/stock';
import { useShop } from '@services/ShopProvider';
import { downloadFile } from './utils';

import styles from './ResetCategoryMarkdownModal.module.scss';

const ResetCategoryMarkdownModal = ({ channel, categoryTitle, deliveryMarkup }) => {
	const { shop } = useShop();
	const [visible, setVisible] = useState(false);
	const [processing, setProcessing] = useState(false);
	const [matches, setMatches] = useState();

	useEffect(() => {
		if (!visible) return;

		(async () => {
			const items = await listStockRecords(shop.id, {
				deliveryCategory: categoryTitle,
				attributes: 'barcode,price,quantity,currency,enabled,title,deliveryCategories,deliveryMarkup'
			});

			const customItems = items.filter((item) => {
				const markup = item.deliveryMarkup?.[channel];
				return markup !== undefined && markup !== null && markup !== deliveryMarkup;
			});

			setMatches(customItems);
		})();
	}, [channel, categoryTitle, deliveryMarkup, visible, shop.id]);

	const resetItems = async () => {
		setProcessing(true);

		for (const item of matches) {
			await customiseProduct(item.barcode, shop.id, {
				deliveryMarkup: {
					...(item.deliveryMarkup || {}),
					[channel]: deliveryMarkup
				}
			});
		}

		setProcessing(false);
		setVisible(false);
		setMatches(undefined);
	};

	return (
		<>
			<TemplateModal
				title={`Reset price markups: ${categoryTitle}`}
				showDismissButton={false}
				onDismiss={() => setVisible(false)}
				isOpen={visible}
			>
				<p>Reset price markups for products in this category. They will be set to the category default markup.</p>

				<div className={styles.itemsSummary}>
					<div>Products with custom markups</div>
					<div className={styles.value}>{matches ? matches.length : 'Finding matches...'}</div>
					{matches?.length > 0 && (
						<button className={styles.downloadButton} onClick={() => downloadFile(matches, channel)}>
							<ArrowDownTrayIcon />
						</button>
					)}
				</div>

				<div className={styles.action}>
					<Button primary onClick={resetItems} disabled={processing}>
						{processing ? 'Resetting...' : 'Reset'}
					</Button>
				</div>
			</TemplateModal>

			<Button link className={styles.resetButton} onClick={() => setVisible(true)}>
				Reset custom products
				<ChevronRightIcon />
			</Button>
		</>
	);
};

export default ResetCategoryMarkdownModal;
